import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ToastContainer } from "react-toastify";
import { createRoot } from "@wordpress/element";
import { $ } from "../utils/constants";
import App from "./App";
import { ModalProvider } from "@/hooks/use-modal";

const queryClient = new QueryClient();

$(document).on("DOMContentLoaded", () => {
    const $container = $(".atml-container");

    if ($container[0]) {
        createRoot($container[0]).render(
            <QueryClientProvider client={queryClient}>
                <ModalProvider>
                    <ToastContainer position="bottom-right" stacked />
                    <App />
                </ModalProvider>
            </QueryClientProvider>
        );
    }
});
